import LegalHero from "@/pages/legal/components/LegalHero";
import RecruitMessage from "@/pages/legal/recruit/components/RecruitMessage";
import RecruitWork from "@/pages/legal/recruit/components/RecruitWork";
import RecruitEnvironment from "@/pages/legal/recruit/components/RecruitEnvironment";
import RecruitRequirements from "@/pages/legal/recruit/components/RecruitRequirements";
import RecruitFlow from "@/pages/legal/recruit/components/RecruitFlow";
import RecruitEntry from "@/pages/legal/recruit/components/RecruitEntry";
import { legalPages } from "@/mocks/legalPages";

export default function RecruitPage() {
  const meta = legalPages.recruit;

  return (
    <>
      <LegalHero path={meta.path} en={meta.en} h1={meta.h1} lead={meta.lead} sub={meta.sub} />

      <RecruitMessage />
      <RecruitWork />
      <RecruitEnvironment />
      <RecruitRequirements />
      <RecruitFlow />
      <RecruitEntry />
    </>
  );
}